import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigarentindaundpune() {



  const cardData =
  {
    keyword: 'Ertiga Rent in Daund Pune',
    heading: 'Sanavi Travels: Ertiga Rent in Daund Pune',
    headingDescription: 'Sanavi Travels offers reliable Ertiga Rent in Daund Pune, providing safe, comfortable, and spacious transportation for families, small groups, corporate travelers, and pilgrims traveling between Daund and Pune. Our fleet of well-maintained Maruti Ertiga vehicles ensures ample seating, air-conditioning, and luggage space for a smooth and hassle-free journey. With professional chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, airport transfers, Shirdi visits, and family outings. Choose Sanavi Travels for trusted Ertiga rental services in Daund Pune, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a haven for bird watchers and nature enthusiasts. Often referred to as the 'Bharatpur of Maharashtra,' it attracts migratory birds such as flamingos, pelicans, storks, and herons, especially during the winter months. Boat rides and early morning visits provide the best wildlife viewing experience."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a tranquil landscape with expansive water views and surrounding greenery. It is ideal for peaceful outings, photography, and birdwatching, especially at sunrise and sunset."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is a local religious site in Daund attracting devotees year-round. The temple is known for its serene spiritual ambiance and traditional ceremonies, making it an important center of devotion in the region."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is a key railway hub in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. Its strategic location makes it significant for travel and trade in the region."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and are home to migratory and resident bird species. Nature walks and boat safaris offer immersive experiences in the rural ecosystem."
  },
  {
    "title": "Local Sugarcane Fields",
    "description": "Daund is surrounded by fertile agricultural lands with sugarcane, grains, and vegetables. Visitors can experience rural farming practices and see Maharashtra’s agricultural lifestyle up close."
  },
  {
    "title": "Village Temples and Wadis",
    "description": "Traditional village temples and wadi shrines around Daund reflect the cultural and religious heritage of the area. These sites are often focal points for local festivals and community gatherings."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund features scenic farmland, open fields, and rural landscapes, perfect for leisurely drives, photography, and experiencing peaceful rural life."
  },
  {
    "title": "Weekly Local Markets",
    "description": "Weekly markets in Daund are vibrant spaces where locals sell fresh produce, grains, household items, and livestock. These markets provide insight into local commerce and traditional rural life."
  },
  {
    "title": "Pilgrimage Transit Point",
    "description": "Daund is strategically located near several religious destinations like Pandharpur and Bhigwan, making it a convenient transit point for pilgrims traveling to major temples and spiritual sites."
  }
]
,



"services": [
  {
    "name": "Ertiga Rent in Daund Pune",
    "description": "Ertiga Rent in Daund Pune provides reliable and convenient car rental services for individuals and families. With well-maintained vehicles, experienced drivers, and flexible rental packages, it is ideal for local travel, outstation trips, airport transfers, and leisure journeys. The service emphasizes comfort, safety, and punctuality, making every ride smooth and stress-free."
  },
  {
    "name": "Ertiga Cab Hire Daund",
    "description": "Ertiga Cab Hire Daund offers easy and professional car rental solutions for both short and long trips. With chauffeur-driven Ertiga vehicles, AC comfort, and flexible scheduling, this service is perfect for corporate travel, family outings, and intercity trips, ensuring timely pickups and comfortable rides."
  },
  {
    "name": "AC Ertiga Daund",
    "description": "AC Ertiga Daund provides fully air-conditioned rides for a comfortable and refreshing travel experience. Ideal for summer travel, business trips, and family outings, the service ensures well-maintained vehicles, trained chauffeurs, and smooth, enjoyable journeys across Daund and nearby locations."
  },
  {
    "name": "Outstation Ertiga Daund",
    "description": "Outstation Ertiga Daund caters to travelers planning trips beyond the city limits. With reliable vehicles, professional drivers, and flexible travel packages, this service ensures safe, timely, and comfortable journeys to nearby cities, tourist destinations, and corporate locations."
  },
  {
    "name": "Family Ertiga Cab Daund",
    "description": "Family Ertiga Cab Daund is designed for family travel, ensuring comfort, safety, and convenience. Spacious seating, air-conditioning, and trained chauffeurs make it perfect for weekend trips, outings, and long-distance journeys with family members."
  },
  {
    "name": "Affordable Ertiga Daund",
    "description": "Affordable Ertiga Daund provides budget-friendly car rental options without compromising on safety or comfort. Ideal for families, students, and corporate travelers, it offers well-maintained vehicles with professional drivers at competitive rates for both local and outstation travel."
  },
  {
    "name": "Chauffeur Driven Ertiga Cab",
    "description": "Chauffeur Driven Ertiga Cab ensures stress-free travel with professional drivers handling navigation, traffic, and scheduling. Perfect for business trips, corporate travel, and family journeys, it offers a smooth, safe, and reliable travel experience."
  },
  {
    "name": "Best Ertiga Service Daund",
    "description": "Best Ertiga Service Daund guarantees top-quality car rental with a focus on reliability, comfort, and punctuality. Offering AC and non-AC options, chauffeur-driven services, and well-maintained vehicles, this service caters to tourists, business travelers, and local commuters seeking premium travel solutions."
  },
  {
    "name": "Railway Pickup Ertiga Daund",
    "description": "Railway Pickup Ertiga Daund provides convenient car service for railway station arrivals and departures. With trained drivers, timely pickups, and comfortable vehicles, travelers can reach their destinations in Daund or nearby areas without any hassle."
  },
  {
    "name": "Tourist Ertiga Daund",
    "description": "Tourist Ertiga Daund is perfect for sightseeing, city tours, and leisure travel. With AC comfort, spacious seating, and experienced chauffeurs, this service ensures a memorable and convenient experience for travelers exploring Daund and surrounding attractions."
  },
  {
    "name": "Corporate Ertiga Daund",
    "description": "Corporate Ertiga Daund provides reliable transportation for business travelers, office staff, and corporate events. With scheduled pickups, professional drivers, and comfortable vehicles, it ensures smooth, punctual, and efficient travel for corporate needs."
  },
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows users to conveniently book Ertiga cabs online with instant confirmation and flexible options. Perfect for local, outstation, or corporate trips, this service offers a hassle-free experience for quick and reliable car rentals."
  },
  {
    "name": "Wedding Ertiga Daund",
    "description": "Wedding Ertiga Daund provides elegant and comfortable Ertiga vehicles for wedding transportation. Ideal for family members, guests, or bridal parties, the service ensures punctuality, chauffeur-driven comfort, and a smooth travel experience for all wedding-related journeys."
  },
  {
    "name": "Local Ertiga Cab",
    "description": "Local Ertiga Cab offers convenient transportation within Daund city for daily commutes, shopping trips, and city sightseeing. With professional drivers and well-maintained vehicles, it ensures a safe, timely, and comfortable local travel experience."
  },
  {
    "name": "Daund Travel Ertiga",
    "description": "Daund Travel Ertiga provides flexible rental options for both local and outstation trips. With AC comfort, spacious interiors, and chauffeur-driven service, it caters to families, tourists, and business travelers seeking reliable and safe travel in and around Daund."
  }
],
"tableData": [
  ["Ertiga Rent in Daund Pune", "Ertiga Cab Hire Daund"],
  ["AC Ertiga Daund", "Outstation Ertiga Daund"],
  ["Family Ertiga Cab Daund", "Affordable Ertiga Daund"],
  ["Chauffeur Driven Ertiga Cab", "Best Ertiga Service Daund"],
  ["Railway Pickup Ertiga Daund", "Tourist Ertiga Daund"],
  ["Corporate Ertiga Daund", "Online Cab Booking Daund"],
  ["Wedding Ertiga Daund", "Local Ertiga Cab"],
  ["Daund Travel Ertiga", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Ertiga Rent in Daund Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable Ertiga rental services between Daund and Pune, ideal for family trips, airport transfers, corporate travel, and outstation journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Ertiga",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced Ertiga vehicles that ensure a smooth and enjoyable ride for your travel between Daund and Pune."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with routes between Daund and Pune, providing safe and timely travel for your journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Ertiga rentals in Daund and Pune, including fuel, tolls, and driver allowances without hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Ertiga rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, local, or customized rental packages based on your travel requirements between Daund and Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Ertiga vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Ertiga rentals in Daund and Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Ertiga rentals in Daund and Pune?',
    answer: 'Yes, Sanavi Travels offers Ertiga rental services between Daund and Pune for comfortable and reliable travel.'
  },
  {
    question: 'How can I book an Ertiga in Daund or Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Is the Ertiga well‑maintained and air‑conditioned?',
    answer: 'Yes, all Ertiga vehicles provided by Sanavi Travels are clean, air‑conditioned, and regularly serviced.'
  },
  {
    question: 'Are drivers experienced with Daund–Pune routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with both local and intercity routes between Daund and Pune.'
  },
  {
    question: 'Can I rent an Ertiga for local and outstation travel?',
    answer: 'Absolutely. You can choose local, one‑way, round‑trip, or customized travel packages based on your needs.'
  },
  {
    question: 'Is the Ertiga rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support for Ertiga rentals in Daund and Pune.'
  },
  {
    question: 'Are the vehicles sanitized before every trip?',
    answer: 'Yes, all Ertiga vehicles are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for Ertiga bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Ertiga rental trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit More',
    feedback: 'Rented an Ertiga between Daund and Pune. Comfortable ride and excellent service by Sanavi Travels.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience with Ertiga rental in Daund and Pune. Clean car, punctual driver, and supportive staff.',
    rating: 5
  }
];






























































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Rent in Daund Pune - Sanavi Travels",
  "description": "Hire an Ertiga cab in Daund with Sanavi Travels. AC, affordable, and chauffeur-driven Ertiga cabs available for local, outstation, corporate, family, wedding, and tourist travel. Online booking and railway pickups available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "85"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Ertiga Rent in Daund Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire an Ertiga cab in Daund with Sanavi Travels. AC, affordable, and chauffeur-driven Ertiga cabs available for local, outstation, corporate, family, wedding, and tourist travel. Online booking and railway pickups available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/115.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigarentindaundpune;